import HorizontalSplit from "./HorizontalSplit";

export default HorizontalSplit;